import { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { enUS, esES, ptBR } from "@mui/x-data-grid/locales";
import { ActThemeProvider } from "@act-group/act-ui-library";
import { useThemeContext } from "../contexts/ThemeContext";
import { getActBrandTheme } from "../theme/actBrandTheme";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";

// MUI X DataGrid locale bundles, keyed by our language codes. These translate
// the grid's built-in chrome ("Rows per page", pagination range, filter/sort
// menus) — text the library DataGrid doesn't expose per-string.
const DATA_GRID_LOCALES: Record<string, object> = {
  en: enUS,
  es: esES,
  pt: ptBR,
};

function AppThemedContent({ children }: { children: ReactNode }) {
  const { darkMode } = useThemeContext();
  const { i18n } = useTranslation();
  const language = i18n.language;

  // Same ACT brand theme as the Demo Console (pink accent, charcoal/#ececec
  // chrome), built for the active mode. Rebuilds on language change so the
  // DataGrid chrome is localised too.
  const theme = useMemo(
    () =>
      getActBrandTheme(darkMode ? "dark" : "light", DATA_GRID_LOCALES[language] ?? enUS),
    [darkMode, language]
  );

  return (
    <ActThemeProvider theme={theme}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </ActThemeProvider>
  );
}

export default AppThemedContent;
